import { TableCell } from "@mui/material";

const EmailAccountHeaderCells = () => (
  <>
    <TableCell>Address</TableCell>
    <TableCell>Display name</TableCell>
    <TableCell>Domain</TableCell>
    <TableCell>Enabled</TableCell>
    <TableCell>Can send</TableCell>
    <TableCell>SMTP login</TableCell>
  </>
);

export default EmailAccountHeaderCells;
